import axios from "axios";
import { dataFeedURL, betaSpreadEndpoint } from "./config";

/**
 * Get all configured BetaSpread pairs
 * @returns {Promise<Array>} List of pair configurations
 */
export const GetBetaSpreadConfigs = async () => {
    try {
        const url = `${dataFeedURL}/${betaSpreadEndpoint}/configs`;
        const response = await axios.get(url);
        return { data: response.data, error: null };
    } catch (ex) {
        console.error('GetBetaSpreadConfigs error:', ex?.response?.data);
        const errorMessage = ex?.response?.data?.message || ex?.response?.data?.error || ex?.message || 'Failed to fetch spread configs';
        return { data: null, error: errorMessage };
    }
};

/**
 * Get 24-hour statistics for a specific symbol pair
 * @param {string} symbol1 - First symbol (e.g., "XAUUSD_c")
 * @param {string} symbol2 - Second symbol (e.g., "XAUEUR_c")
 * @param {number} hours - Time window in hours (default: 24)
 * @returns {Promise<Object>} Statistics object with min/max/volatility data
 */
export const GetPairStatistics = async (symbol1, symbol2, hours = 24) => {
    try {
        const url = `${dataFeedURL}/${betaSpreadEndpoint}/${symbol1}/${symbol2}/statistics?hours=${hours}`;
        const response = await axios.get(url);
        return { data: response.data, error: null };
    } catch (ex) {
        console.error(`GetPairStatistics error for ${symbol1}/${symbol2}:`, ex?.response?.data);
        const errorMessage = ex?.response?.data?.message || ex?.response?.data?.error || ex?.message || 'Failed to fetch pair statistics';
        return { data: null, error: errorMessage };
    }
};

/**
 * Get latest spread value for a symbol pair
 * @param {string} symbol1 - First symbol
 * @param {string} symbol2 - Second symbol
 * @returns {Promise<Object>} Latest spread data point
 */
export const GetLatestSpread = async (symbol1, symbol2) => {
    try {
        const url = `${dataFeedURL}/${betaSpreadEndpoint}/${symbol1}/${symbol2}/latest`;
        const response = await axios.get(url);
        return { data: response.data, error: null };
    } catch (ex) {
        console.error(`GetLatestSpread error for ${symbol1}/${symbol2}:`, ex?.response?.data);
        const errorMessage = ex?.response?.data?.message || ex?.response?.data?.error || ex?.message || 'Failed to fetch latest spread';
        return { data: null, error: errorMessage };
    }
};

/**
 * Get BetaSpread calculator statistics (total counts)
 * @returns {Promise<Object>} Calculator statistics (ticks processed, spreads calculated, etc.)
 */
export const GetCalculatorStatistics = async () => {
    try {
        const url = `${dataFeedURL}/${betaSpreadEndpoint}/statistics`;
        const response = await axios.get(url);
        return { data: response.data, error: null };
    } catch (ex) {
        console.error('GetCalculatorStatistics error:', ex?.response?.data);
        const errorMessage = ex?.response?.data?.message || ex?.response?.data?.error || ex?.message || 'Failed to fetch calculator statistics';
        return { data: null, error: errorMessage };
    }
};
